import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import className from 'classnames';
import { ConnectedAirportSelectorInputMobile } from './AirportSelectorInputMobile';
import { ConnectedAirportSelectorDropdown } from './AirportSelectorDropdown';
import { LocationUtils, ABUtils, withPageContext } from '../../utils';
import { LocationProp, LegTypeProps } from '../../models';

export const AirportSelectorMobile = ({
    fetchedLocations,
    focus,
    setValue,
    sources,
    value,
    departureOrArrival,
    activeProduct,
    errorMessage,
}) => {
    const { isInteractionImprovements, isCssVariationMobile } = ABUtils.getABs();
    const initialStateWord = isInteractionImprovements
        ? ''
        : LocationUtils.getInputText(value, activeProduct);
    const [displayedWord, setDisplayedWord] = useState(initialStateWord);
    const [ownFocus, setOwnFocus] = useState(focus);
    const airportSelectorRef = useRef();

    const classNames = className({
        'prisma-input-group': isCssVariationMobile,
        'odf-mobile-input-group': !isCssVariationMobile,
        'focused': ownFocus,
        'valid': !ownFocus && displayedWord.length > 0 && errorMessage,
        'invalid': !ownFocus && displayedWord.length > 0 && !!errorMessage,
    });

    const handleClickOutside = () => {
        setOwnFocus(false);
        if (!value) {
            setDisplayedWord('');
            setValue(undefined);
        }
    };

    const handleClick = (event) => {
        if (!airportSelectorRef.current.contains(event.target) && ownFocus) {
            handleClickOutside();
        }
    };

    const onClickItem = (value) => {
        setDisplayedWord(LocationUtils.getInputText(value));
        setOwnFocus(false);
        setValue(value);
    };

    const onChangeInput = (text) => {
        setDisplayedWord(text);
        setValue(undefined);
    };

    const onFocusInput = () => setOwnFocus(true);

    useEffect(() => {
        setOwnFocus(focus);
    }, [focus]);

    useEffect(() => {
        document.addEventListener('touchend', handleClick);
        return () => document.removeEventListener('touchend', handleClick);
    }, [ownFocus, displayedWord, fetchedLocations, handleClick]);

    return (
        <div className={classNames} ref={airportSelectorRef}>
            <ConnectedAirportSelectorInputMobile
                focus={ownFocus}
                displayedWord={displayedWord}
                departureOrArrival={departureOrArrival}
                onChangeInput={onChangeInput}
                onFocusInput={onFocusInput}
                errorMessage={errorMessage}
            />
            <ConnectedAirportSelectorDropdown
                activeProduct={activeProduct}
                displayedWord={displayedWord}
                focus={ownFocus}
                onClickItem={onClickItem}
                sources={sources}
                isFixedWidth
                hasBoxStyle={!isCssVariationMobile}
                departureOrArrival={departureOrArrival}
            />
        </div>
    );
};

AirportSelectorMobile.propTypes = {
    fetchedLocations: PropTypes.object,
    focus: PropTypes.bool.isRequired,
    setValue: PropTypes.func.isRequired,
    sources: PropTypes.array.isRequired,
    value: LocationProp,
    departureOrArrival: LegTypeProps.isRequired,
    errorMessage: PropTypes.string,
};

AirportSelectorMobile.defaultProps = {
    fetchedLocations: {},
    value: null,
    errorMessage: '',
};

const mapStateToProps = ({ locationAutocomplete, activeProduct }) => ({
    fetchedLocations: locationAutocomplete.locations,
    activeProduct: activeProduct.activeProduct,
});

const connected = connect(mapStateToProps, {})(withPageContext(AirportSelectorMobile));
export { connected as ConnectedAirportSelectorMobile };
